export enum ERoutes {
  CLAIM_JOBS = 'CLAIM_JOBS',
  CLAIM_JOBS_SLUG = 'CLAIM_JOBS_SLUG'
}
